import { useState, useRef } from "react";
import Accounts from "./Accounts/Accounts";
import AccounsSummary from "./Accounts/AccountsSummary";
import { Box } from "@mui/material";
import {
	useWalletsQuery,
	useNetWorthQuery,
} from "../../../services/queryHooks";
import { Loading } from "../../../components/common/Loading";
import NetWorthGraph from "./NetWorthGraph";
import ChangePeriodRow from "../../../components/common/ChangePeriodRow";
import { useTheme } from "@mui/material/styles";

function NettWorth() {
	const todayRef = useRef(null);

	if (!todayRef.current) {
		const now = new Date();
		const todayUTC = new Date(
			Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
		);
		todayRef.current = todayUTC.toISOString();
	}

	const today = todayRef.current;

	const [periodType, setPeriodType] = useState("Monthly");
	const [period, setPeriod] = useState(today);
	const { data: wallets, isPending: walletsLoading } = useWalletsQuery();

	const { data: netWorth, isPending: netWorthLoading } = useNetWorthQuery(
		period,
		periodType
	);

	const theme = useTheme();

	const categoryKeys = [
		{ key: "Cash", color: "#10B981", translationKey: "cash" },
		{ key: "Real Estate", color: "#3B82F6", translationKey: "realEstate" },
		{ key: "Vehicles", color: "#8B5CF6", translationKey: "vehicles" },
		{ key: "Valuables", color: "#F59E0B", translationKey: "valuables" },
		{
			key: "Other",
			color: theme.palette.categories.default,
			translationKey: "other",
		},
		{ key: "Mortgage", color: "#EF4444", translationKey: "mortgage" },
		{ key: "Credit Card", color: "#DC2626", translationKey: "creditCard" },
		{ key: "Car Loan", color: "#B91C1C", translationKey: "carLoan" },
		{
			key: "Student loan",
			color: "#991B1B",
			translationKey: "studentLoan",
		},
	];

	if (walletsLoading) {
		return <Loading />;
	}

	return (
		<>
			<ChangePeriodRow
				period={period}
				setPeriod={setPeriod}
				periodType={periodType}
				setPeriodType={setPeriodType}
				periodTypeOptions={["Monthly", "Daily"]}
			/>
			<NetWorthGraph
				period={period}
				periodType={periodType}
				netWorth={netWorth}
				netWorthLoading={netWorthLoading}
				categoryKeys={categoryKeys}
			/>
			<Box sx={{ display: "flex", flexWrap: "wrap", m: 2, gap: 2 }}>
				<Accounts wallets={wallets} />
				<AccounsSummary wallets={wallets} categoryKeys={categoryKeys} />
			</Box>
		</>
	);
}

export default NettWorth;
